export default {
  usage: 'Usage',
  parameters: 'Parameters',
  body: 'Body',
  bodyHint: 'Leave the body empty to use the default body. A changed body applies to every report.',
  copyDefaultBody: 'Copy default body',
  resetBody: 'Use default body',
};
